import * as React from 'react'

import { Text, TextName } from 'sdk/text/Text'

import type { AboutLeadershipCmsContent } from 'core/services/cms/interfaces'

import { LeadershipTeamCard } from './components/LeadershipTeamCard'

import classes from './style.module.scss'

interface LeadershipTeamSectionProps {
  content: AboutLeadershipCmsContent
}

export const LeadershipTeamSection: React.FC<LeadershipTeamSectionProps> = ({ content }) => {
  return (
    <div className={classes.container}>
      <Text type={TextName.H2} className={classes.title}>
        {content.title}
      </Text>
      <Text type={TextName.Text} className={classes.description}>
        {content.description}
      </Text>
      <div className={classes.cardsGrid}>
        {content.members.map((leader, index) => (
          <LeadershipTeamCard key={index} leader={leader} />
        ))}
      </div>
    </div>
  )
}
